import { render, staticRenderFns } from "./ExamAttributeChildrenGroup.vue?vue&type=template&id=7836adac&scoped=true&"
import script from "./ExamAttributeChildrenGroup.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeChildrenGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeChildrenGroup.vue?vue&type=style&index=0&id=7836adac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836adac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
